<template>
  <div class="payment-selector-modal">
    <div class="payment-selector-modal__container">
      <div class="payment-selector-modal__mask">
        <div class="payment-selector-modal__title-wrapper">
          <h4 class="payment-selector-modal__subtitle">Replace payment method on file</h4>
          <button
            @click="handleCloseModal"
            class="payment-selector-modal__close-btn btn btn--tertiary btn--small btn--training"
          >
            <CloseModalXIcon />
          </button>
        </div>
        <div class="payment-selector-modal__selector-wrapper">
          <PaymentMethodListItems @close-payment-selector-modal="handleCloseModal" />
        </div>
        <div class="payment-selector-modal__cta-warning">
          <PaymentMethodListWarning />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import PaymentMethodListItems from '@/components/PaymentMethodListItems.vue'
import PaymentMethodListWarning from '@/components/PaymentMethodListWarning.vue'
import CloseModalXIcon from '@/assets/icons/close_modal_x.svg'
import { eventsConstants } from '@/helpers/eventsList'

export default {
  name: 'PaymentSelectorModal',
  components: {
    PaymentMethodListItems,
    PaymentMethodListWarning,
    CloseModalXIcon: { ...CloseModalXIcon, name: 'CloseModalXIcon' },
  },
  methods: {
    ...mapMutations({
      setIsPaymentSelectorModalShown: 'app/IS_PAYMENT_SELECTOR_MODAL_SHOWN_UPDATED',
    }),
    handleCloseModal() {
      this.setIsPaymentSelectorModalShown(false)
    },
    handleClick() {
      this.setIsPaymentSelectorModalShown(false)
      this.setIsPaymentModalShown(true)
      this.$store.dispatch('events/sendBrazeEventAction', {
        event_name: eventsConstants.CHECKOUT_CART_UPDATED,
        properties: {
          trigger: 'changePaymentMethod',
        },
      })
    },
  },
}
</script>

<style lang="scss">
.payment-selector-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
    z-index: 9999;
  }
  &__container {
    background: #222222;
    height: 100vh;
    width: 100vw;
    @include tablet {
      border-radius: 35px;
      width: 500px;
      height: 443px;
    }
  }
  &__mask {
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    padding: 40px;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-rows: 15% 140px auto;
    @include tablet {
      border-radius: 35px;
    }
  }
  &__title {
    font-family: var(--font-bold);
    color: var(--white);
    font-size: 18px;
    margin: 30px 0 20px 0;
    padding: 0;
    text-align: left;
    @include mobile {
      margin: 15px 0;
      text-align: center;
      font-size: 24px;
    }
    @include tablet {
      text-align: left;
    }
    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }
  &__subtitle {
    font-family: var(--font-regular);
    font-size: 16px;
    line-height: 24px;
    color: var(--light-blue-gray);
    margin: -5px 0 0 0;
  }
  &__selector-wrapper {
    width: 100%;
    display: flex;
  }
  &__close-btn {
    border: none;
    background: transparent;
    color: var(--white);
    font-family: var(--font-regular);
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
